module.exports = __webpack_public_path__ + "img/img2.9441e4c6.png";